import { ITaskListItem } from "@/src/api/tasksPageRequests";
import { ITasksTableRow } from "@/src/types/tasksTable";
import { resolveDisplayDegreeAndCourse } from "@/src/utils/admissionOffice/resolveDisplayDegreeAndCourse";
import { mapTaskApiStatusToUi } from "./mapTaskStatus";
import {
  parseTaskApplicantId,
  parseTaskApplicantInfo,
  parseTaskNumericId,
  parseTaskUserEmail,
  parseTaskUserId,
} from "./parseTaskApplicantInfo";

export const mapTaskListItemToTableRow = (item: ITaskListItem): ITasksTableRow => {
  const applicantInfo = parseTaskApplicantInfo(item.applicant_info);
  const rawLevelEducation = String(applicantInfo.level_education ?? applicantInfo.levelEducation ?? "").trim();
  const { degree, course } = resolveDisplayDegreeAndCourse(item.selected_course ?? "", rawLevelEducation);
  const formOffice = applicantInfo.form_office ?? "";

  return {
    task_id: parseTaskNumericId(item.id),
    student_id: parseTaskApplicantId(applicantInfo, item.applicant_id),
    created_date: item.created_at ?? "",
    full_name: applicantInfo.fullname ?? applicantInfo.full_name ?? "",
    assignee_id: parseTaskUserId(item.assignee, item.assignee_id),
    assignee_email: parseTaskUserEmail(item.assignee),
    executor_id: parseTaskUserId(item.executor, item.executor_id),
    executor_email: parseTaskUserEmail(item.executor),
    whoose: item.whoose ?? "",
    type: item.type ?? "",
    intake: item.intake ?? "",
    admission_semester: item.admission_semester ?? "",
    form_of_education: item.form_of_education ?? "",
    level_education: degree,
    course,
    category: item.category ?? "",
    medium_of_instruction: item.medium_of_instruction ?? "",
    duration: item.duration ?? "",
    transfer_fee: item.transfer_fee ?? "",
    priority: item.priority ?? "",
    note: item.note ?? "",
    deadline_date: item.deadline_date ?? "",
    status: mapTaskApiStatusToUi(item.status ?? "", { attached_file: item.attached_file }),
    office: formOffice,
    form_office: formOffice,
    date_of_birth: applicantInfo.birth_date ?? applicantInfo.dateOfBirth ?? "",
    attached_file: item.attached_file ?? null,
    fullname_nat: applicantInfo.fullname_nat ?? applicantInfo.fullnameNat ?? "",
    nationality: applicantInfo.nationality ?? "",
    selected_course: course,
    tuition_fee: item.tuition_fee ?? "",
    medical_insurance: item.medical_insurance ?? "",
    residence_permit: item.residence_permit ?? "",
    other_expenses: item.other_expenses ?? "",
    acommodation: item.acommodation ?? "",
    admission_fee: item.admission_fee ?? "",
    complete_one_year: item.complete_one_year ?? "",
    color_star: "default",
    is_read: true,
  };
};

export const getTaskListItemId = (item: ITaskListItem): string => String(item.id);
